import React, { Component } from "react";
import { Subscribe } from "unstated";

import buttonActionHelper from "../../../utils/helpers/buttonActionHelper";
import StateContainer from "../../../state/StateContainer";
import stringHelper from "../../../utils/helpers/stringHelper";

class DefaultButton extends Component {
  state = {
    isHovered: false,
  };

  formatButtonStyles = (button, backgroundImageUrl) => {
    if(button.iconUrl)
    return {
      backgroundImage: `Url(${
        this.state.isHovered
          ? button.hoverIconUrl
            ? button.hoverIconUrl
            : button.iconUrl
          : button.iconUrl
      })`,
    };

    if(backgroundImageUrl) 
        return {
          backgroundImage: `Url(${backgroundImageUrl})`
    }

    if(button.name === "Fullscreen") {
      return {
        right:
          this.props.unstated.state.orbViews.length > 0 ? "80px" : "60px",
      };
    }
     
    return {
      display: "block",
      backgroundColor: `${
        this.props.backgroundColor
          ? stringHelper.removeAplhaFromColor(this.props.backgroundColor)
          : null
      }`,
    };
  }


  render() {
    return (
      <React.Fragment>
      {this.props.unstated.state.customButtons !== undefined
        ? this.props.unstated.state.customButtons.map((button) => {
            if (button.name !== this.props.buttonName || !button.isActive) {
              return null
            }
            return (
              <button
                key={button.name}
                style={this.formatButtonStyles(button, this.props.backgroundImage)}
                className={this.props.buttonClass}
                onClick={() => {
                  buttonActionHelper.executeActions(
                    button.actions,
                    this.props.unstated,
                    "click"
                  );
                }}
                onMouseEnter={() => {
                  this.setState({isHovered: true})
                  buttonActionHelper.executeActions(
                    button.actions,
                    this.props.unstated,
                    "mouseenter"
                  );
                }}
                onMouseLeave={() => {
                  this.setState({isHovered: false})
                  buttonActionHelper.executeActions(
                    button.actions,
                    this.props.unstated,
                    "mouseleave"
                  );
                }}
              >{button.text}</button>
            );
          })
        : null}
    </React.Fragment>
    );
  }
}

const DefaultButtonWithUnstated = (props) => {
  return (
    <Subscribe to={[StateContainer]}>
      {unstated => <DefaultButton {...props} unstated={unstated}/>}
    </Subscribe>
  )
}

export default DefaultButtonWithUnstated;
